import { ClassData } from '@models/class-data';
import { EventTicket } from './event-ticket.model';
import { EventAttendeeTicketOrder } from './event-attendee-ticket-order.model';
import { EventAttendee } from '@models/event-attendance/event-attendee.model';
import moment from 'moment';
import { DataField } from '@models/data-fields/data-field.model';
import { EventAttendeeQuestion } from '@models/event-attendance/event-attendee-question.model';

export class EventAttendeeTicket {
  id: number;
  createdAt?: Date;

  uuid: string;

  ticketNumber: string;

  eventAttendeeTicketOrderId: number;
  eventAttendeeTicketOrder?: EventAttendeeTicketOrder;
  eventTicketId: number;
  eventTicket?: EventTicket;

  eventAttendeeId?: number;
  eventAttendee?: EventAttendee;

  basePrice: number;
  price: number;

  isUsed: boolean;
  usedDate?: Date;

  constructor(json: ClassData<EventAttendeeTicket>) {
    this.id = +json.id;
    if (json.createdAt) {
      this.createdAt = new Date(json.createdAt);
    }

    this.uuid = json.uuid;
    this.ticketNumber = json.ticketNumber;

    this.eventAttendeeTicketOrderId = +json.eventAttendeeTicketOrderId;
    if (json.eventAttendeeTicketOrder) {
      this.eventAttendeeTicketOrder = new EventAttendeeTicketOrder(
        json.eventAttendeeTicketOrder,
      );
    }
    this.eventTicketId = +json.eventTicketId;
    if (json.eventTicket) {
      this.eventTicket = new EventTicket(json.eventTicket);
    }

    if (json.eventAttendeeId) {
      this.eventAttendeeId = +json.eventAttendeeId;
    }
    if (json.eventAttendee) {
      this.eventAttendee = new EventAttendee(json.eventAttendee);
    }

    this.basePrice = json.basePrice;
    this.price = json.price;

    this.isUsed = json.isUsed;
    if (json.usedDate) {
      this.usedDate = new Date(json.usedDate);
    }
  }

  getCheckedInInfo(): string {
    if (this.isUsed && this.usedDate) {
      return moment(this.usedDate).format('DD.MM.YYYY | HH:mm');
    }

    return '~';
  }

  getDatePaidDisplay(): string {
    if (
      !this.eventAttendeeTicketOrder ||
      !this.eventAttendeeTicketOrder.datePaid
    ) {
      return '~';
    }

    return moment(this.eventAttendeeTicketOrder.datePaid).format(
      'DD.MM.YYYY | HH:mm',
    );
  }

  getTicketName(): string {
    let name = '';

    const group = this.eventAttendeeTicketOrder?.eventSlot?.group;
    if (group?.name) {
      name = group.name;
    }

    if (!name && this.eventTicket?.name) {
      name = this.eventTicket.name;
    }

    return name;
  }

  getTicketDescription(): string {
    let desc = '';

    const group = this.eventAttendeeTicketOrder?.eventSlot?.group;
    if (group?.description) {
      desc = group.description;
    }

    if (!desc && this.eventTicket?.description) {
      desc = this.eventTicket.description;
    }

    return desc;
  }

  isAssigned(): boolean {
    return !!this.eventAttendeeId;
  }

  getDataFieldsAsEventAttendeeQuestion(): EventAttendeeQuestion[] | undefined {
    if (this.eventAttendeeTicketOrder?.eventSlot) {
      return this.eventAttendeeTicketOrder?.eventSlot.getDataFieldsAsEventAttendeeQuestion();
    }

    return this.eventTicket?.getDataFieldsSortedAsEventAttendeeQuestion();
  }
}
